'use client';
import {useEffect,useSyncExternalStore} from "react";
import {browserGamepad} from "../lib/services/input/browser-gamepad";
export function useGamepad(){
  const snapshot=useSyncExternalStore(browserGamepad.subscribe,browserGamepad.getSnapshot,browserGamepad.getServerSnapshot);
  useEffect(()=>browserGamepad.acquire(),[]);
  return snapshot;
}
